import axios from 'axios';
import { config } from '../apiConfig';

const Member = async (parameters) => {
    let result = '';
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
        let response = await axios.post(`${config.url}/api/mvc/OrganizationMember/AddNewMember`, parameters, {
            headers: { "Authorization": `Bearer ${AccessToken}` }
        }).catch((err) => {
            return err.response;
        });
        return response.data == "" ? "success" : response.data;
    } else {
        window.location.href = 'https://iranhotelonline.com';
    }
}

export default Member;